const statuses = {
  1: 'Da Esitare',
  2: 'Eseguito',
  3: 'Non Eseguito',
}
export default {
  namespaced: true,

  getters: {
    getAppointmentStatusLabel: () => id => statuses[id],
  },
}
